/* eslint-disable @angular-eslint/no-output-on-prefix */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css'],
})
export class NavComponent implements OnInit {
  @Output() onSearchChange = new EventEmitter<string>();
  @Output() onFilterClick = new EventEmitter();
  @Input() searchValue?: string = '';
  constructor() {}

  ngOnInit() {}
}
